import AppSwitcher from './AppSwitcher.component';

export default AppSwitcher;
